import script from "./AppOutdatedPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppOutdatedPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./AppOutdatedPlaceholder.vue?vue&type=style&index=0&id=ab594138&lang=css"

const __exports__ = script;

export default __exports__